import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "@/lib/auth";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ChevronLeft } from "lucide-react";

export default function AdminDirectoryImportPage() {
  const api = useApi();
  const nav = useNavigate();
  const [craft, setCraft] = useState("");
  const [ra, setRa] = useState("");
  const [busy, setBusy] = useState(false);
  const [stats, setStats] = useState(null);

  const loadStats = async () => {
    const r = await api("/admin/member-directory/stats");
    if (r.ok) setStats(await r.json());
  };
  useEffect(() => { loadStats(); /* eslint-disable-next-line */ }, []);

  const importCsv = async (type, csv) => {
    if (!csv.trim()) return toast.error("Paste CSV content first");
    setBusy(true);
    try {
      const path = type === "craft" ? "/admin/member-directory/import-craft" : "/admin/member-directory/import-royal-arch";
      const r = await api(path, { method: "POST", body: JSON.stringify({ csv }) });
      const d = await r.json();
      if (!r.ok) return toast.error(d.detail || "Import failed");
      toast.success(`Imported ${d.inserted || 0} rows, updated ${d.updated || 0}.`);
      loadStats();
    } finally { setBusy(false); }
  };

  return (
    <div>
      <button onClick={() => nav("/admin")} className="text-sm text-primary inline-flex items-center gap-1 mb-4"><ChevronLeft size={16}/> Back</button>
      <PageHeader title="Import members directory" subtitle="Paste the CSV export from Portal's Advanced view." testId="directory-import-header" />

      {stats && (
        <Card className="p-4 mb-4 text-sm text-muted-foreground">
          Directory: <span className="font-medium text-foreground">{stats.total || 0}</span> rows ·
          {" "}Craft: <span className="font-medium text-foreground">{stats.craft || 0}</span> ·
          {" "}Royal Arch: <span className="font-medium text-foreground">{stats.royal_arch || 0}</span>
        </Card>
      )}

      <div className="grid gap-4 md:grid-cols-2">
        <Card className="p-5">
          <h3 className="font-semibold mb-2">Craft Advanced CSV</h3>
          <div className="space-y-1">
            <Label>Paste CSV</Label>
            <Textarea rows={12} value={craft} onChange={(e) => setCraft(e.target.value)} placeholder="GL_Ref,First,Surname,Lodge,..." data-testid="dir-craft-csv" />
          </div>
          <Button onClick={() => importCsv("craft", craft)} disabled={busy} className="mt-3" data-testid="dir-craft-import">Import Craft CSV</Button>
        </Card>
        <Card className="p-5">
          <h3 className="font-semibold mb-2">Royal Arch Advanced CSV</h3>
          <div className="space-y-1">
            <Label>Paste CSV</Label>
            <Textarea rows={12} value={ra} onChange={(e) => setRa(e.target.value)} placeholder="RA_Ref,First,Surname,Chapter,..." data-testid="dir-ra-csv" />
          </div>
          <Button onClick={() => importCsv("royalarch", ra)} disabled={busy} className="mt-3" data-testid="dir-ra-import">Import Royal Arch CSV</Button>
        </Card>
      </div>
    </div>
  );
}
